const PATH = "/api/v1/zoworld";

const ENDPOINTS = {
  ZOWORLD_COUNTRIES: "/countries/",
  ZOWORLD_CULTURES: "/cultures/",
  ZOWORLD_METADATA: "/metadata/",
};

export type ZoWorldEndpoints = keyof typeof ENDPOINTS;
export const ZoWorldCollection = { PATH, ENDPOINTS };
